/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon, {BaseProps} from "../Base"

const ShareTo = (props: BaseProps) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00008 15.3334C3.63341 15.3334 3.31953 15.2028 3.05841 14.9417C2.7973 14.6806 2.66675 14.3667 2.66675 14V6.66669C2.66675 6.30002 2.7973 5.98613 3.05841 5.72502C3.31953 5.46391 3.63341 5.33335 4.00008 5.33335H6.00008V6.66669H4.00008V14H12.0001V6.66669H10.0001V5.33335H12.0001C12.3667 5.33335 12.6806 5.46391 12.9417 5.72502C13.2029 5.98613 13.3334 6.30002 13.3334 6.66669V14C13.3334 14.3667 13.2029 14.6806 12.9417 14.9417C12.6806 15.2028 12.3667 15.3334 12.0001 15.3334H4.00008ZM7.33342 10.6667V3.21669L6.26675 4.28335L5.33341 3.33335L8.00008 0.666687L10.6667 3.33335L9.73342 4.28335L8.66675 3.21669V10.6667H7.33342Z"
      />
    </BaseSvgIcon>
  )
}

export default ShareTo
